module.exports = __webpack_public_path__ + "static/media/masdar-logo-white.f9f061a1.svg";